import {
    activity3StudentMoveCastle,
    activity4ComputerMove,
    lesson11QA6,
    lesson11QA8,
    notationTable
} from './assignments'
import { highlightCoordinates } from '../commonActivities'
import { BLACK_PIECE_SEARCH_KEY, WHITE_INITIAL_MOVE, WHITE_PIECE_SEARCH_KEY, BLACK_INITIAL_MOVE } from '../../utils/constants';

let lessonConfig = [
    {
        id: 0,
        previous: null,
        next: 2,
        video: {
            src: 'img/videos/lesson_11/1.mp4',

            startTime: 0,
            autoStartNext: true,
            next: 1
        }
    },
    {
        id: 1,
        previous: 0,
        next: 2,
        audio: { src: 'img/audio/lesson_11/1.mp3', start: true, controls: false },
        chessboard: {
            board: highlightCoordinates({
                showIndicators: { allSides: true },
                coordinates: ['.square-b2', '.square-d5', '.square-f6', '.square-a8'],
                coordinateClass: 'filled-square',
                position: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
                reminder: true,
                bubbleConfig: {
                    data: 'Good job!',
                    position: 'left'
                },
                next: 2
            }),
        },
        directions: {
            data: `<b>DIRECTIONS:</b><br/>For quick practice, click on b2, d5, f6, and a8.`
        }
    },
    {
        id: 2,
        previous: 0,
        next: 4,
        video: {
            src: 'img/videos/lesson_11/2.mp4',
            autoStartNext: true,
            next: 3
        }
    },
    {
        id: 3,
        previous: 2,
        next: 4,
        text: {
            data: 'Make the moves according to the Notation sheet <br/>on the right.<br/>You are playing White.',
            styleClass: 'xxl'
        },
        chessboard: {
            board: notationTable({
                showIndicators: { allSides: true },
                position: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
                resultFen: 'rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR',
                restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
                initialMoveOf: WHITE_INITIAL_MOVE,
                moves: {
                    studentMove: {
                        from: ['d2', 'c2', 'b1', 'c1', 'e2'],
                        to: ['d4', 'c4', 'c3', 'g5', 'e3']
                    },
                    computerMove: {
                        from: ['d7', 'e7', 'g8', 'f8'],
                        to: ['d5', 'e6', 'f6', 'e7']
                    }
                },
                assignmentClass: 'custom-sparepiece',
                next: 4,
            }),
            positionFen: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w - - 0 1'
        },
        directions: {
            data: `<table style="width:100%;">
                    <colgroup>
                        <col />
                        <col />
                        <col style="background-color:#D3D3D3;"/>
                    </colgroup>
                    <thead><tr><th colspan="3"><b>Notation Sheet</th></tr></thead>
                    <tbody>
                        <tr><th style="padding:10px;">Moves</th><th>White</th><th>Black</th></tr>
                        <tr><td style="padding:10px;">1</td><td>d2-d4</td><td>d7-d5</td></tr>
                        <tr><td style="padding:10px;">2</td><td>c2-c4</td><td>e7-e6</td></tr>
                        <tr><td style="padding:10px;">3</td><td>Nb1-c3</td><td>Ng8-f6</td></tr>
                        <tr><td style="padding:10px;">4</td><td>Bc1-g5</td><td>Bf8-e7</td></tr>
                        <tr><td style="padding:10px;">5</td><td>e2-e3</td><td>0-0</td></tr>
                    </tbody>
            </table>`
        }
    },
    {
        id: 4,
        previous: 2,
        next: 7,
        video: {
            src: 'img/videos/lesson_11/3.mp4',
            autoStartNext: true,
            next: 5
        }
    },
    {
        id: 5,
        previous: 4,
        next: 7,
        text: {
            data: 'Make the moves according to the Notation sheet <br/>on the right.<br/>You are playing Black.',
            styleClass: 'xxl'
        },
        chessboard: {
            board: notationTable({
                showIndicators: { allSides: true },
                position: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
                resultFen: 'rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR',
                restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
                initialMoveOf: BLACK_INITIAL_MOVE,
                firstMove: 'black',
                blackCastle: 6,
                moves: {
                    studentMove: {
                        from: ['e7', 'b8', 'f8', 'g8'],
                        to: ['e5', 'c6', 'c5', 'f6']
                    },
                    computerMove: {
                        from: ['e2', 'g1', 'f1', 'c2', 'd2'],
                        to: ['e4', 'f3', 'c4', 'c3', 'd3']
                    }
                },
                assignmentClass: 'custom-sparepiece',
                next: 6,
            }),
            positionFen: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w - - 0 1'
        },
        directions: {
            data: `<table style="width:100%;">
            <colgroup>
                <col />
                <col />
                <col style="background-color:#D3D3D3;"/>
            </colgroup>
            <thead><tr><th colspan="3"><b>Notation Sheet</th></tr></thead>
            <tbody>
                <tr><th style="padding:10px;">Moves</th><th>White</th><th>Black</th></tr>
                <tr><td style="padding:10px;">1</td><td>e2-e4</td><td>e7-e5</td></tr>
                <tr><td style="padding:10px;">2</td><td>Ng1-f3</td><td>Nb8-c6</td></tr>
                <tr><td style="padding:10px;">3</td><td>Bf1-c4</td><td>Bf8-c5</td></tr>
                <tr><td style="padding:10px;">4</td><td>c2-c3</td><td>Ng8-f6</td></tr>
                <tr><td style="padding:10px;">5</td><td>d2-d3</td><td>0-0</td></tr>
            </tbody>
    </table>`,
        }
    },
    {
        id: 6,
        previous: 4,
        next: 7,
        text: {
            data: `Do a King's side castle.`,
            timeout: 4000,
            position: 'left',
            styleClass: 'xs'
        },
        chessboard: {
            board: activity3StudentMoveCastle({
                showIndicators: { allSides: true },
                position: 'r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQK2R',
                finalPosition: 'r1bq1rk1/pppp1ppp/2n2n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQK2R',
                assignmentClass: 'custom-sparepiece',
                next: 7,
                startChance: 'b KQkq - 0 1',
                kingTarget: 'g8',
                rookTarget: 'f8',
                source: 'e8',
                target: 'g8'
            }),
            positionFen: 'r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQK2R b KQkq - 0 1'
        },
        directions: {
            data: `<table style="width:100%;">
            <colgroup>
                <col />
                <col />
                <col style="background-color:#D3D3D3;"/>
            </colgroup>
            <thead><tr><th colspan="3"><b>Notation Sheet</th></tr></thead>
            <tbody>
                <tr><th style="padding:10px;">Moves</th><th>White</th><th>Black</th></tr>
                <tr><td style="padding:10px;">1</td><td>e2-e4</td><td>e7-e5</td></tr>
                <tr><td style="padding:10px;">2</td><td>Ng1-f3</td><td>Nb8-c6</td></tr>
                <tr><td style="padding:10px;">3</td><td>Bf1-c4</td><td>Bf8-c5</td></tr>
                <tr><td style="padding:10px;">4</td><td>c2-c3</td><td>Ng8-f6</td></tr>
                <tr><td style="padding:10px;">5</td><td>d2-d3</td><td>0-0</td></tr>
            </tbody>
    </table>`,
        }
    },
    {
        id: 7,
        previous: 4,
        next: 16,
        video: {
            src: 'img/videos/lesson_11/4.mp4',
            autoStartNext: true,
            next: 8
        }
    },
    {
        id: 8,
        previous: 7,
        next: 16,
        directions: {
            data: `<b>DIRECTIONS</b><br/>Select the correct notation for the move`,
            timeout: 0,
            className: 'no-animation'
        },
        options: {
            id: 0,
            answer: [
                'PE4',
                'e2-e4',
                'd4'
            ],
            validateCounter: true,
            count: 0,
            rightAnswer: 'e2-e4',
            magnusWrongAnswer: {
                data: `Oops!, The notation looks like this --> <b>e2-e4</b>`,
                styleClass: 'lg',
            },
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'xs',

        },
        chessboard: {
            board: activity4ComputerMove({
                showIndicators: { allSides: true },
                position: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
                finalPosition: 'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
                from: 'e2',
                to: 'e4',
                next: 9
            })
        }
    },
    {
        id: 9,
        previous: 7,
        next: 16,
        directions: {
            data: `<b>DIRECTIONS</b><br/>Select the correct notation for the move`,
            timeout: 0,
            className: 'no-animation'
        },
        options: {
            id: 1,
            answer: [
                'e2-e4',
                'e4-e5',
                'e7-e5'
            ],
            validateCounter: true,
            count: 0,
            rightAnswer: 'e7-e5',
            magnusWrongAnswer: {
                data: `Oops!, The notation looks like this --> <b>e7-e5</b>`,
                styleClass: 'lg',
            },
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'xs',

        },
        chessboard: {
            board: activity4ComputerMove({
                showIndicators: { allSides: true },
                position: 'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
                finalPosition: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',
                from: 'e7',
                to: 'e5',
                next: 10
            })
        }
    },
    {
        id: 10,
        previous: 7,
        next: 16,
        directions: {
            data: `<b>DIRECTIONS</b><br/>Select the correct notation for the move`,
            timeout: 0,
            className: 'no-animation'
        },
        options: {
            id: 2,
            answer: [
                'K-f3',
                'Ng1-f3',
                'f3-e4'
            ],
            validateCounter: true,
            count: 0,
            rightAnswer: 'Ng1-f3',
            magnusWrongAnswer: {
                data: `Oops!, The notation looks like this --> <b>Ng1-f3</b>`,
                styleClass: 'lg',
            },
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'xs',

        },
        chessboard: {
            board: activity4ComputerMove({
                showIndicators: { allSides: true },
                position: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',
                finalPosition: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
                from: 'g1',
                to: 'f3',
                next: 11
            })
        }
    },
    {
        id: 11,
        previous: 7,
        next: 16,
        directions: {
            data: `<b>DIRECTIONS</b><br/>Select the correct notation for the move`,
            timeout: 0,
            className: 'no-animation'
        },
        options: {
            id: 3,
            answer: [
                'Nb8-c6',
                'Kt-qb6',
                'C6-B8'
            ],
            validateCounter: true,
            count: 0,
            rightAnswer: 'Nb8-c6',
            magnusWrongAnswer: {
                data: `Oops!, The notation looks like this --> <b>Nb8-c6</b>`,
                styleClass: 'lg',
            },
            validateAnswer: { rightAnswer: 0, userAnswer: -1 },
            styleClass: 'xs',

        },
        chessboard: {
            board: activity4ComputerMove({
                showIndicators: { allSides: true },
                position: 'rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
                finalPosition: 'r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
                from: 'b8',
                to: 'c6',
                next: 12
            })
        }
    },
    {
        id: 12,
        previous: 7,
        next: 16,
        directions: {
            data: `<b>DIRECTIONS</b><br/>Select the correct notation for the move`,
            timeout: 0,
            className: 'no-animation'
        },
        options: {
            id: 4,
            answer: [
                'bb6',
                'Bf1-b5',
                'Nf3-Bb5'
            ],
            validateCounter: true,
            count: 0,
            rightAnswer: 'Bf1-b5',
            magnusWrongAnswer: {
                data: `Oops!, The notation looks like this --> <b>Bf1-b5</b>`,
                styleClass: 'lg',
            },
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'xs',

        },
        chessboard: {
            board: activity4ComputerMove({
                showIndicators: { allSides: true },
                position: 'r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
                finalPosition: 'r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',
                from: 'f1',
                to: 'b5',
                next: 13
            })
        }
    },
    {
        id: 13,
        previous: 7,
        next: 16,
        directions: {
            data: `<b>DIRECTIONS</b><br/>Select the correct notation for the move`,
            timeout: 0,
            className: 'no-animation'
        },
        options: {
            id: 5,
            answer: [
                'A6C6',
                'a7-a6',
                'A6-B5'
            ],
            validateCounter: true,
            count: 0,
            rightAnswer: 'a7-a6',
            magnusWrongAnswer: {
                data: `Oops!, The notation looks like this --> <b>a7-a6</b>`,
                styleClass: 'lg',
            },
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'xs',

        },
        chessboard: {
            board: activity4ComputerMove({
                showIndicators: { allSides: true },
                position: 'r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',
                finalPosition: 'r1bqkbnr/1ppp1ppp/p1n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',
                from: 'a7',
                to: 'a6',
                next: 14
            })
        }
    },
    {
        id: 14,
        previous: 7,
        next: 16,
        directions: {
            data: `<b>DIRECTIONS</b><br/>Select the correct notation for the move`,
            timeout: 0,
            className: 'no-animation'
        },
        options: {
            id: 6,
            answer: [
                'XBN',
                'c6b5x',
                'Bb5xc6'
            ],
            validateCounter: true,
            count: 0,
            rightAnswer: 'Bb5xc6',
            magnusWrongAnswer: {
                data: `Oops!, The notation looks like this --> <b>Bb5xc6</b>`,
                styleClass: 'lg',
            },
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'xs',

        },
        chessboard: {
            board: activity4ComputerMove({
                showIndicators: { allSides: true },
                position: 'r1bqkbnr/1ppp1ppp/p1n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',
                finalPosition: 'r1bqkbnr/1ppp1ppp/p1B5/4p3/4P3/5N2/PPPP1PPP/RNBQK2R',
                assignmentClass: 'custom-sparepiece',
                from: "b5",
                to: "c6",
                capture: {
                    capturingPiece: 'wB',
                    capturedPiece: 'bN'
                },
                next: 15
            }),
        }
    },
    {
        id: 15,
        previous: 7,
        next: 16,
        directions: {
            data: `<b>DIRECTIONS</b><br/>Select the correct notation for the move`,
            timeout: 0,
            className: 'no-animation'
        },
        options: {
            id: 7,
            answer: [
                'Pdx6c',
                'd7xc6',
                'PXP'
            ],
            validateCounter: true,
            count: 0,
            rightAnswer: 'd7xc6',
            magnusWrongAnswer: {
                data: `Oops!, The notation looks like this --> <b>d7xc6</b>`,
                styleClass: 'lg',
            },
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'xs',

        },
        chessboard: {
            board: activity4ComputerMove({
                showIndicators: { allSides: true },
                position: 'r1bqkbnr/1ppp1ppp/p1B5/4p3/4P3/5N2/PPPP1PPP/RNBQK2R',
                finalPosition: 'r1bqkbnr/1pp2ppp/p1p5/4p3/4P3/5N2/PPPP1PPP/RNBQK2R',
                assignmentClass: 'custom-sparepiece',
                from: 'd7',
                to: 'c6',
                capture: {
                    capturingPiece: 'bP',
                    capturedPiece: 'wB'
                },
                next: 16
            })
        }
    },
    {
        id: 16,
        previous: 7,
        next: 17,
        video: {
            src: 'img/videos/lesson_11/5.mp4',
            autoStartNext: true,
            next: 17
        }
    },
    {
        id: 17,
        previous: 16,
        next: 18,
        audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
        qa: {
            id: 0,
            question: "What part of chess notation uses capital letters?",
            answer: [
                'The captures',
                'The squares',
                'The pieces',
                'Checkmate'
            ],
            rightAnswer: 'The pieces',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'md'
        }
    },
    {
        id: 18,
        previous: 16,
        next: 19,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 1,
            question: "When you are playing as Black, where do your moves get recorded?",
            answer: [
                'On the right',
                'On the left',
                'On the top',
                'On the bottom'
            ],
            rightAnswer: 'On the right',
            validateAnswer: { rightAnswer: 0, userAnswer: -1 },
            styleClass: 'md'
        },
        directions: {
            data: `<table style="width: 100%;">
                <colgroup>
                <col />
                <col />
                <col />
                </colgroup>
                <thead><tr><th colspan=3>Notation Sheet</th></tr></thead>
                <tbody><tr><th style="width: 33%;">Moves</th><th></th><th></th></tr>
                    <tr><td>1</td><td></td><td></td></tr>
                    <tr><td>2</td><td></td><td></td></tr>
                    <tr><td>3</td><td></td><td></td></tr>
                    <tr><td>4</td><td></td><td></td></tr>
                    <tr><td>5</td><td></td><td></td></tr></tbody>
            </table>`
        }
    },
    {
        id: 19,
        previous: 16,
        next: 20,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 2,
            question: "What is the Knight's symbol?",
            answer: [
                'K',
                '@',
                '#',
                'N'
            ],
            rightAnswer: 'N',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'md'
        }
    },
    {
        id: 20,
        previous: 16,
        next: 21,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 3,
            question: "Why is it a good idea to record your game?",
            answer: [
                'You can review your game later',
                'It helps you become a better player',
                'Most tournaments require it',
                'All of the above'
            ],
            rightAnswer: 'All of the above',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'md'
        }
    },
    {
        id: 21,
        previous: 16,
        next: 22,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 4,
            question: "What does <b>Nf3xe5</b> mean?",
            answer: [
                'Notation starts on f3',
                'The Knight on f3 is capturing the piece on e5',
                'The Knight on f3 has the e5 King in check',
                'Three times five is fifteen Knights'
            ],
            rightAnswer: 'The Knight on f3 is capturing the piece on e5',
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'xl'
        }
    },
    {
        id: 22,
        previous: 16,
        next: 23,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 5,
            question: "How would you record White’s last move?",
            answer: [
                'f6-g7',
                'f6xg7',
                'f6xg7+',
                'f6xg7#'
            ],
            rightAnswer: 'f6xg7#',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: lesson11QA6({
                    showIndicators: true,
                    position: '2R3qk/1p4p1/p4P1K/P2p4/3P4/8/8/2R5',
                    finalPosition: '2R3qk/1p4P1/p6K/P2p4/3P4/8/8/2R5',
                    assignmentClass: 'custom-sparepiece',
                    from: "f6",
                    to: "g7",
                    capture: {
                        capturingPiece: 'wP',
                        capturedPiece: 'bP'
                    }
                }),
                hint: true
            },
        }
    },
    {
        id: 23,
        previous: 16,
        next: 24,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 6,
            question: "Which of these moves is the correct way to record a checkmate?",
            answer: [
                'Qd1-d8x',
                'Qd1-d8+',
                'Qd1-d8#',
                'Qd1-d8$'
            ],
            rightAnswer: 'Qd1-d8#',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'md'
        }
    },
    {
        id: 24,
        previous: 16,
        next: 25,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 7,
            question: "Which of these is the correct way to record Black’s move ?",
            answer: [
                'Ke8-c8',
                '0-0',
                'Ra8-d8',
                '0-0-0'
            ],
            rightAnswer: '0-0-0',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: lesson11QA8({
                    showIndicators: true,
                    position: 'r3kbnr/ppqn1pp1/2p1p2p/7P/2PP4/3Q1NN1/PP1B1PP1/R3K2R',
                    finalPosition: '2kr1bnr/ppqn1pp1/2p1p2p/7P/2PP4/3Q1NN1/PP1B1PP1/R3K2R'
                }),
                hint: true
            },
        }
    },
    {
        id: 25,
        previous: 16,
        next: 26,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 8,
            question: "The White and Black Kings both start on…",
            answer: [
                'The 1st rank, e1 and d1',
                'The d-file, d1 and d8 Kings are dangerous',
                'The e-file e1 and e8 Kings oversee Everything',
                'Their own colored square, just like the Queens'
            ],
            rightAnswer: 'The e-file e1 and e8 Kings oversee Everything',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'xl'
        }
    },
    {
        id: 26,
        previous: 16,
        next: 27,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 9,
            question: "Using chess notation is a good idea because:",
            answer: [
                'You can review your game later to improve your play',
                'Writing down the moves helps you to focus',
                'If you decide to play in tournaments it is required',
                'All of the above'
            ],
            rightAnswer: 'All of the above',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'lg'
        }
    },
    {
        id: 27,
        previous: 16,
        next: null,
        audio: { src: null, stop: true },
        qa: {
            position: 'center',
            result: true,
            nextLesson: 'Lesson Twelve',
            styleClass: 'xl'
        }
    }
];

let assets = [
    '/img/background_10.png',
    '/img/background_11.png',
    '/img/background_12.png'
];

let config = {
    config: lessonConfig,
    assets: assets
};

export default config;



// WEBPACK FOOTER //
// ./src/lessons/lesson_11/index.js